const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const fetchWithAuth = async (url, options = {}) => {
    const response = await fetch(`${API_BASE_URL}${url}`, {
        ...options,
        credentials: 'include',
    });

    if (response.status === 401) {
        console.error('Authentication expired or failed for:', url);
        localStorage.removeItem('currentUser');
        window.location.href = '/login';
        throw new Error('Unauthorized');
    }

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: 'Unknown error' }));
        throw new Error(errorData.detail || errorData.message || 'API request failed');
    }

    return response.json();
};

// Community Organizations API
export const fetchCommunityOrganizations = async (familyId, filters = {}) => {
    const params = new URLSearchParams();
    for (const key in filters) {
        if (filters[key] !== undefined && filters[key] !== null) {
            params.append(key, filters[key]);
        }
    }
    const queryString = params.toString();
    return fetchWithAuth(`/v1/families/${familyId}/community_organizations${queryString ? `?${queryString}` : ''}`);
};

export const getCommunityOrganization = async (familyId, orgId) => {
    return fetchWithAuth(`/v1/families/${familyId}/community_organizations/${orgId}`);
};

export const createCommunityOrganization = async (familyId, orgData) => {
    return fetchWithAuth(`/v1/families/${familyId}/community_organizations`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(orgData),
    });
};

export const updateCommunityOrganization = async (familyId, orgId, orgData) => {
    return fetchWithAuth(`/v1/families/${familyId}/community_organizations/${orgId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(orgData),
    });
};

export const deleteCommunityOrganization = async (familyId, orgId) => {
    return fetchWithAuth(`/v1/families/${familyId}/community_organizations/${orgId}`, {
        method: 'DELETE',
    });
};

